import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const BusinessOnlyField = ({ limitSelectOptions, disabled }) => {
  return (
    <Field name="business_cases" parse={({ value }) => value}>
      {({ input }) => (
        <Fragment>
          <label>Business Cases Only</label>
          <Select
            {...input}
            clearable={false}
            options={limitSelectOptions}
            className="form-select"
            disabled={disabled}
          />
        </Fragment>
      )}
    </Field>
  );
};

BusinessOnlyField.propTypes = {
  limitSelectOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

BusinessOnlyField.defaultProps = {
  disabled: false,
};

export default BusinessOnlyField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/BusinessOnlyField.jsx